// extracted by mini-css-extract-plugin
export default {"mainDiv":"sdwt_mainDiv__+3twP","hidden":"sdwt_hidden__K6mvV","title":"sdwt_title__LtaUX","content":"sdwt_content__AawDU"};